import { FormFieldValue } from '../types';

export class ContactFormField {
  protected readonly minLength: number | null;
  protected readonly maxLength: number | null;

  constructor(minLength?: Nullable<number>, maxLength?: Nullable<number>) {
    this.minLength = this.isNaN(minLength)
      ? null
      : this.getNumberWhenPositiveOrThrow(Number(minLength));
    this.maxLength = this.isNaN(maxLength)
      ? null
      : this.getNumberWhenPositiveOrThrow(Number(maxLength));
    this.checkMinAndMaxLengthRelation();
  }

  private getNumberWhenPositiveOrThrow(value: number): number {
    const numberValue = Number(value);
    if (numberValue < 0) {
      throw Error('Value of minLength/maxLength when provided should be a non-negative number');
    }
    return numberValue;
  }

  private checkMinAndMaxLengthRelation() {
    if (this.minLength != null && this.maxLength != null && this.minLength > this.maxLength) {
      throw Error('Value of minLength should be greater or equal to maxLength value');
    }
  }

  private isNaN(value: Nullable<number>) {
    // @ts-ignore
    return isNaN(value) || value == null;
  }

  protected isEmpty(value: FormFieldValue): boolean {
    return this.trim(value).length === 0;
  }

  private trim(value: FormFieldValue): FormFieldValue {
    if (typeof value === 'string') {
      return value.trim();
    }
    return value;
  }
}
